export default __webpack_public_path__ + "static/O0002-92f3b09b3d8222fc65f5076171f53dac.png";